module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__costs-zones"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.zonesAmount,
      "link": "",
      "table-id": "zones"
    },
    on: {
      "refresh": _vm.getZones,
      "create": _vm.addZone
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.zones),
      callback: function($$v) {
        _vm.zones = $$v
      },
      expression: "zones"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5e46cda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/Zones.vue
// module id = 1269
// module chunks = 0